export default __webpack_public_path__ + "static/media/xero.dc9903f2.svg";